'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var App = require('app');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');

var errorMessages = {
    device_update_failed: i18n.TR('Änderungen konnten nicht gespeichert werden.'),
    device_connection_failed: i18n.TR('Die Verbindung zu dem Gerät konnte nicht hergestellt werden.'),
};

var BaseDeviceSettingsView = AbstractFormView.extend({
    // To implement/define in sub-class:
    // - template
    // - getInputFields()
    // - getUpdatedModel(form)
    // - getNewModel(form)

    // Optional:
    // - handleUpdatedModel(form) - return false if not handled

    controller: undefined,

    events: {
        'click button#js-success': 'validateForm',
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.dialog = options.dialog || this;
        this.model = options.model;
        this.parent_id = options.parent_id;
        this.updateCallback = options.cb;

        this.isModal = this.dialog === this;
        var formData =
            options.formData || (options.model ? options.model.toJSON() : undefined) || this.getFormDefaults() || {};

        AbstractFormView.prototype.initialize.apply(this, [
            {
                formData: formData,
                inputFields: this.getInputFields(),
            },
        ]);
    },

    getFormDefaults: function () {},

    serializeData: function () {
        var data = AbstractFormView.prototype.serializeData.apply(this, arguments);
        data.asModalDialog = this.isModal;
        return data;
    },

    updateModel: function (form, callback) {
        var self = this;
        this.controller.updateModel({
            model: this.model,
            updated_model: this.getUpdatedModel(form),
            success: function (model, resp) {
                if (callback) {
                    var callbackWasHandled = callback(self, model);
                    if (callbackWasHandled) {
                        return;
                    }
                }

                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen gespeichert.'));
                App.hideModal();
                self.updateCallback(true, self.model.id, self.model.attributes.category);
                App.trigger(self.model.type + ':show', self.model.id);
            },
            error: function (errors) {
                self.errors = (errors && errors.error ? errors : undefined) ||
                    (errors ? { error: errors } : undefined) || { error: i18n.TR('Unbekannter Fehler') };
                self.errors.error = errorMessages[self.errors.error] || self.errors.error;
                self.formData = form;

                if (self.isModal) {
                    App.refreshModal(self);
                } else {
                    self.render();
                }

                self.updateCallback(false);
            },
        });
    },

    createModel: function (form, callback) {
        var self = this;
        var model = this.getNewModel(form, this.parent_id, this.options.categoryKey);

        this.controller.createModel({
            model: model,
            success: function (model) {
                var callbackWasHandled = callback(self, model);
                if (callbackWasHandled) {
                    return;
                }

                App.hideModal();
                self.updateCallback(true, model.id, model.attributes.category);
                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Gerät hinzugefügt.'));
            },
            error: function (errors) {
                self.errors = (errors && errors.error ? errors : undefined) ||
                    (errors ? { error: errors } : undefined) || { error: i18n.TR('Unbekannter Fehler') };
                self.errors.error = errorMessages[self.errors.error] || self.errors.error;
                self.formData = form;

                // HACK - "unwrap" form error message
                if (typeof errors === 'object') {
                    _.each(self.errors.error, function (a, b) {
                        self.errors.error = a;
                    });
                }

                if (self.isModal) {
                    App.refreshModal(self);
                } else {
                    self.render();
                }

                self.updateCallback(false);
            },
        });
    },

    validateForm: function (e, callback, createCallback) {
        if (e) {
            e.preventDefault();
        }
        var self = this;

        if (this.allFieldsValid()) {
            var form = Backbone.Syphon.serialize(this);
            Decorator.disableElement('.modal-dialog');

            if (this.model) {
                if (this.handleUpdatedModel !== undefined) {
                    if (this.handleUpdatedModel(form)) {
                        return;
                    }
                }
                this.updateModel(form, callback);
            } else {
                this.createModel(form, createCallback);
            }
        }
    },
});

module.exports = BaseDeviceSettingsView;
